import * as React from "react";

const Dazon = () => {
  return (
    <ol className="references">
     <li>
      Centers for Disease Control and Prevention. Understanding AIDS brochure. 1988; HHS Publication No. (CDC) HHS-88-8404. Accessed February 18, 2022.&nbsp;
      <a target="_blank" className="" href="https://stacks.cdc.gov/view/cdc/6927">https://stacks.cdc.gov/view/cdc/6927</a>
      </li>
      <li>
        Kaiser Family Foundation. Women and HIV in the United States. Published March 9, 2020. Accessed February 14, 2022.&nbsp;
        <a target="_blank" className="" href="https://www.kff.org/hivaids/fact-sheet/women-and-hivaids-in-the-united-states/">https://www.kff.org/hivaids/fact-sheet/women-and-hivaids-in-the-united-states/</a>
      </li>
      <li>
        Singh S, Hu X, Hess K. Estimating the lifetime risk of a diagnosis of HIV infection in the United States. Abstract presented at: virtual Conference on Retroviruses and Opportunistic Infections (vCROI) 2022; February 12–16, 2022. Accessed February 14, 2022.&nbsp;
        <a target="_blank" className="" href="https://www.croiconference.org/abstract/estimating-the-lifetime-risk-of-a-diagnosis-of-hiv-infection-in-the-united-states/">https://www.croiconference.org/abstract/estimating-the-lifetime-risk-of-a-diagnosis-of-hiv-infection-in-the-united-states/</a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV and women. Published March 2021. Accessed February 14, 2022.&nbsp;
        <a target="_blank" className="" href="https://www.cdc.gov/hiv/pdf/group/gender/women/cdc-hiv-women.pdf">https://www.cdc.gov/hiv/pdf/group/gender/women/cdc-hiv-women.pdf</a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV in the southern United States. Published September 2019. Accessed February 14, 2022.&nbsp;
        <a target="_blank" className="" href="https://www.cdc.gov/hiv/pdf/policies/cdc-hiv-in-the-south-issue-brief.pdf">https://www.cdc.gov/hiv/pdf/policies/cdc-hiv-in-the-south-issue-brief.pdf</a>
      </li>
      <li>
        Ojikutu BO, Mayer K. HIV prevention among Black women in the US—time for multimodal integrated strategies. <i>JAMA Netw Open</i>. 2021;4(4):e215356.
      </li>
      <li>
        Prather C, Fuller TR, Jeffries 4th WL, et al. Racism, African American women, and their sexual and reproductive health: a review of historical and contemporary evidence and implications for health equity. <i>Health equity</i>. 2018;2(1):249-259.
      </li>
      <li>
        Centers for Disease Control and Prevention. STDs and HIV – CDC fact sheet. Updated March 5, 2021. Accessed February 14, 2022.&nbsp;
         <a target="_blank" className="" href="https://www.cdc.gov/std/hiv/stdfact-std-hiv.htm">https://www.cdc.gov/std/hiv/stdfact-std-hiv.htm</a>
      </li>
      <li>
        Centers for Disease Control and Prevention. Health disparities in HIV, viral hepatitis, STDs, and TB: African Americans/Blacks. Updated September 14, 2020. Accessed February 14, 2022.&nbsp;
         <a target="_blank" className="" href="https://www.cdc.gov/nchhstp/healthdisparities/default.htm">https://www.cdc.gov/nchhstp/healthdisparities/default.htm</a>
      </li>
      <li>
        Ojikutu BO, Bogart LM, Higgins-Biddle M, et al. Facilitators and barriers to pre-exposure prophylaxis (PrEP) use among Black individuals in the United States: results from the National Survey on HIV in the Black Community (NSHBC). <i>AIDS Behav</i>. 2018;22(11):3576-3587.
      </li>
      <li>
        Walcott M, Kempf MC, Merlin JS, Turan JM. Structural community factors and sub-optimal engagement in HIV care among low-income women in the deep South of the USA. <i>Cult Health Sex</i>. 2016;18(6):682-694.
      </li>
      <li>
        Randolph SD, Golin C, Welgus H, Lightfoot AF, Harding CJ, Riggins LF. How perceived structural racism and discrimination and medical mistrust in the health system influences participation in HIV health services for Black women living in the United States South: a qualitative, descriptive study. <i>J Assoc Nurses AIDS Care</i>. 2020;31(5):598-605.
      </li>
      <li>
        Painter TM, Herbst JH, Diallo DD, White LD; Centers for Disease Control and Prevention (CDC). Community-based program to prevent HIV/STD infection among heterosexual black women. <i>MMWR Suppl</i>. 2014;63(1):15-20.
      </li>
      <li>
        Copen CE. Condom use during sexual intercourse among women and men aged 15–44 in the United States: 2011–2015 National Survey of Family Growth. <i>Natl Health Stat Report</i>. 2017;(105):1-18.
      </li>
      <li>
        Stokes LR, Brody LR. Self-silencing, but not sexual relationship power associated with condom use for Black college-aged women. <i>Behav Sci (Basel)</i>. 2019;9(2):13.
      </li>
      <li>
        Crosby RA, DiClemente RJ, Salazar LF, et al. Predictors of consistent condom use among young African American women. <i>AIDS Behav</i>. 2013;17(3):865-871.
      </li>
      <li>
        Centers for Disease Control and Prevention. Healthy Love: a single session, group-level HIV prevention. Reviewed January 21, 2020. Accessed February 14, 2022.&nbsp;
        <a target="_blank" className="" href="https://www.cdc.gov/hiv/research/interventionresearch/rep/packages/healthylove.html">https://www.cdc.gov/hiv/research/interventionresearch/rep/packages/healthylove.html</a>
      </li>
      <li>
        Gilbert L, Goddard-Eckrich D, Chang M, et al. Effectiveness of a culturally tailored HIV and sexually transmitted infection prevention intervention for Black women in community supervision programs: a randomized clinical trial. <i>JAMA Netw Open</i>. 2021;4(4):e215226.
      </li>
    </ol>
  )
  }

export default Dazon;